import { useEffect } from "react";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];
const STORAGE_KEY = "yn.attribution";

/**
 * Reads UTM params + referrer on first landing, stashes them in sessionStorage
 * so every subsequent lead submission (or event that wants attribution) can
 * pull them from getAttribution(). No cookies, no third-party pixels.
 */
export function useUtmCapture() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const existing = sessionStorage.getItem(STORAGE_KEY);
      if (existing) return; // already captured on landing

      const params = new URLSearchParams(window.location.search);
      const payload = {};
      let anyUtm = false;
      for (const k of UTM_KEYS) {
        const v = params.get(k);
        if (v) {
          payload[k] = v;
          anyUtm = true;
        }
      }
      const referrer =
        document.referrer && !document.referrer.includes(window.location.host)
          ? document.referrer
          : null;
      if (referrer) payload.referrer = referrer;

      if (anyUtm || referrer) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      }
    } catch (_e) {
      // sessionStorage may be unavailable (private mode), silent fail
    }
  }, []);
}

export function getAttribution() {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (_e) {
    return {};
  }
}
